export function cyclePercentage(moment, cycle, endTime) {
  let startTime = cycle.countStart
  let forecastDuration = parseFloat(
    cycle.forecastDurationMinutes + cycle.forecastHoldStatusMinutes
  )
  let minutes = moment.duration(moment(endTime).diff(moment(startTime))).asMinutes()

  let cyclePercentage = minutes / forecastDuration

  return isFinite(cyclePercentage) ? parseFloat((cyclePercentage * 100).toFixed(1)) : 2
}
